<template lang="pug">
.index-slider
    .splide()
        .splide__track
            ul.splide__list
                .splide__slide(v-for="(item,key) in data" :key="key" :data-id="item.id")
                    .index-image
                        //<i class="fa fa-circle-o-notch fa-spin"></i>
                        .loading
                            i.fa.fa-circle-o-notch.fa-spin
                            |  {{LANG.imageLoading}}
                        .bg(:style="'background-image:url('+item.imgUrl+')'")
                        a(:href="item.url" target="_blank")
    .dolike(@dblclick="editorReview()")
        #doUnlike.like-act(@click="doLike('unlike')")
            i.fa.fa-thumbs-o-down
        #doLike.like-act(@click="doLike('like')")
            i.fa.fa-heart
</template>
<div class="splide " >
    <div class="splide__track">
        <ul class="splide__list" id="">
            {foreach $indexRecommend $item}
            <li class="splide__slide">
                <div class="index-image" style="background-image:url({$item.imgUrl})">
                </div>

            </li>
            {/foreach}
        </ul>
    </div>
</div>
<script>

import util from   "../lib/util"
import $ from "jquery"
import Vue from 'vue'
export default {
    name: 'IndexSlider',
    components: {
    },
    data() {
        return {
            next : [],
            splide : null,
            showPage : window.vueCfg.page,
            LANG : window.LANG,
            data : [],

            //loading Data
            reachedLast : false,
            isLoading : false,
            page : window.vueCfg.page,

            //hint
            isSupWebP : util.isSupWebP(),
            isMobile : util.isMobile()
        }
    },
    beforeMount : function(){
        let mThis = this;

        window.preloadData = new Map();
        window.curImgId = 0;

        this.mobileBar();

        this.preload(()=>{
            var pData = window.preloadData.get( mThis.page );
            mThis.renderData(pData);
            mThis.renderSlider();
        } , this.page );

    },
    methods : {

        renderSlider(){
            var mThis = this;
            $('#renderLoading').hide();
            var timer = setInterval(()=>{
                if ( typeof Splide == 'undefined'){
                    return;
                }
                clearInterval(timer);
                var itemsLength = 0;
                var splide = new Splide( '.splide' , {
                    height : "100%",
                    fixedHeight : "100%",
                    direction: 'ttb',
                    arrows : false,
                    wheel    : true,
                    rewind: true,
                    rewindByDrag : true,
                    keyboard : 'global',
                    paginationDirection : 'ttb'
                });
                splide.on('move',(newIndex,preIndex,destIndex)=>{

                    $('#doLike').removeClass('active');
                    if ( itemsLength == 0 ){
                        console.log('no length data');
                        return;
                    }
                    if ( newIndex == 0 && preIndex >= itemsLength - 3 ){
                        mThis.renderNext();
                        mThis.preload(()=>{
                            mThis.preload(()=>{
                                mThis.preload();
                            });
                        });
                    }
                });

                splide.mount();
                itemsLength = splide.length;
                mThis.splide = splide;
                mThis.preload(()=>{
                    mThis.preload();
                });
            },100);
        },

        renderNext(){
            if ( this.showPage > this.page ){
                console.log('renderPage out of curPage');
                return;
            }
            this.showPage++;
            //window.preloadData.set(mThis.page , data);
            var pData = window.preloadData.get(this.showPage);
            if ( typeof pData == 'undefined'){
                console.log(`no data for page ${this.showPage}`);
                this.showPage--;
                return;
            }
            //this.data = pData;
            this.renderData(pData);
        },
        preload(callback , setPage ){

            if ( this.reachedLast || this.isLoading ){
                console.log('reachedLastPage or loading... ' );
                return ;
            }
            if ( this.loadingReqs >= 16 ){
                console.log('TooMany Requests ... ' );
                return ;
            }
            var mThis = this , reqPage = this.page;
            if ( isNaN(setPage) ){
                this.page ++;
            }

            this.isLoading = true;
            var url = `/index/slideData/?ajax=1&page=${this.page}`;
            if ( this.isMobile ){
                url = url.replace(/slideData/g , 'slideDataMobile');
            } else {
                url = url.replace(/slideData/g , 'slideDataPC');
            }
            $.getJSON(url,(rep)=>{
                if (rep.errorCode != 0){
                    return;
                }
                var data = [];
                mThis.isLoading = false;
                data = rep.msg;

                if (data.length == 0){
                    mThis.reachedLast = true;
                    return;
                }
                window.preloadData.set( reqPage , data);
                callback && callback();
            });
        },

        renderData(data){
            var mThis = this;
            if ( !this.isSupWebP ){
                this.data = data;
            } else {
                var ret = [];
                for(var x in data){
                    data[x].imgUrl = data[x].imgUrl + ".webp";
                    ret.push(data[x]);
                }
                this.data = ret;
            }
        },
        mobileBar(){
            $('.navbar-toggler').click(function(){

                var expand = $(this).attr('aria-expanded');//aria-expanded="true"
                setTimeout(()=>{

                },300);
                if ( expand != 'true'){
                    $('#topNavBar').addClass('bg-dark');
                } else {
                    $('#topNavBar').removeClass('bg-dark');
                }

                console.log('asdfsadffsafd',expand);

            });
        },
        doLike(type){
            var imgId = $(".splide__list").find('.is-active').attr('data-id');
            var url = `/api/photos/doLike/?from=index&pid=${imgId}&r=` + Math.random();
            if ( type == 'unlike' ){
                url = url + "&type=unlike";
                if (this.splide != null ){
                    this.splide.go('>');
                }
            } else {
                $('#doLike').addClass('active');
            }
            $.getJSON(url);
        },
        editorReview(){
            var imgId = $(".splide__list").find('.is-active').attr('data-id');
            $('#doUnlike').addClass("reviewing");
            console.log('reviewing');
            $.getJSON(`/api/photos/editorBad/?pid=${imgId}&r=` + Math.random(),()=>{
                $('#doUnlike').removeClass("reviewing");
            });
        }


    }
}
</script>



// WEBPACK FOOTER //
// src/modules/IndexSlider.vue